
import * as handlebars_family from "../handlebars_family.js";

const TPL = handlebars_family.addTemplate("feed/list-cartridge",{"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<flexrow class=\"fw-margin-responsive fw-border1\" style=\"margin-top:0px\" data-fw-onclick=\"goto|tasks.php?metaId="
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"metaId") : depth0), depth0))
    + "\"><icon style=\"width:60px;\"><i class=\"color-branded\" style=\"color:"
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"color") : depth0), depth0))
    + ";width:32px;\">"
    + ((stack1 = container.lambda((depth0 != null ? lookupProperty(depth0,"iconsimple") : depth0), depth0)) != null ? stack1 : "")
    + "</i></icon><flexauto style=\"line-height:150%\" class=\"fw-padding-responsive\"><p>"
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"name") : depth0), depth0))
    + "</p><p class=\"sub2\">"
    + ((stack1 = lookupProperty(helpers,"i18n").call(depth0 != null ? depth0 : (container.nullContext || {}),"catsystem.remaining",{"name":"i18n","hash":{},"data":data,"loc":{"start":{"line":1,"column":341},"end":{"line":1,"column":373}}})) != null ? stack1 : "")
    + "</p></flexauto></flexrow>";
},"useData":true});
export default TPL;